import React from "react";
import "../index.css";

const Experience = () => {
    return (
        <section id="experience" className="py-3">
            <div className="container">
                <h2 className="fw-bold mb-4">Experience</h2>

                {/* First Journey */}

                <div className="mb-4">
                    <div className="d-flex">
                        <div className="line me-4 border-bottom border-5"></div> {/* Add the line here */}
                        <div className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="fw-bold">Financial Analyst</h3>
                                <p className="fw-bold job-date">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-calendar-event"
                                        viewBox="0 0 16 16"
                                        style={{ marginRight: "8px", color: "#4C82F7" }} // Adjust color & spacing
                                    >
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                        <path d="M4.5 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
                                    </svg>
                                    September 2021 – July 2023
                                </p>

                            </div>
                            <p className="company-link">
                                <a
                                    href="https://oxbridgedigital.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="company-link-text"
                                >
                                     Oxbridge Digital | Remote, United Kingdom
                                </a>
                            </p>
                            <div>
                                <ul className="mt-3">
                                    <li>
                                        Automated financial reporting  using  VBA macros and SQL, reducing reporting cycle times by 30% and improving data integrity across multiple processes.
                                    </li>
                                    <li>
                                        Recovered over £225,000 in past-due receivables by implementing targeted, data-driven collection strategies, achieving a  55% reduction in overdue invoices within 12 months.
                                    </li>
                                    <li>Developed interactive financial dashboards using Power BI and Tableau , visualizing client portfolio trends and performance metrics. Presented insights to stakeholders, driving timely and informed decision-making.
                                    </li>
                                    <li>Streamlined financial operations by drafting an  Internal Controls & Procedures Manual  in compliance with SECP and local governance laws, resulting in enhanced reporting accuracy and ethical financial practices.
                                    </li>
                                    <li>Analyzed 15+ marketing campaigns (online and offline), optimizing vendor selection and reducing costs by 34% over a  7-month period.
                                    </li>
                                    <li>Conducted feasibility reports for existing clients and potential contracts in collaboration with a team of 7, integrating  market segment analysis and risk factors, leading to improved project approval rates.
                                    </li>
                                    <li>Identified operational inefficiencies through  cost-driver analysis, optimizing capital allocation and achieving a  34% decrease in client cost metrics and a 12% reduction in operational costs.
                                    </li>
                                    <li>Designed scalable solutions for financial controls and internal reporting, collaborating across departments including engineering and data analytics.
                                    </li>
                                </ul>
                                {/* <h6 className="fw-bold">•	Skills and Technicals Used:
                                </h6> */}
                                <ul className="mt-3">
                                    
                                    <div className="skills-list">
                                        <span className="skill-badge">Power BI</span>
                                        <span className="skill-badge">Tableau</span>
                                        <span className="skill-badge">Python</span>
                                        <span className="skill-badge">SQL</span>
                                        <span className="skill-badge">Excel VBA</span>
                                        <span className="skill-badge">Internal controls development</span>
                                        <span className="skill-badge">Cost analysis</span>
                                        <span className="skill-badge">Variance Analysis</span>
                                        <span className="skill-badge">Feasibility analysis</span>
                                        <span className="skill-badge">Financial Dashboards</span>
                                        <span className="skill-badge">Cross-functional team collaboration</span>
                                        <span className="skill-badge">Stakeholder presentation</span>
                                        {/* Add more skills here */}
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Experience;
